import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=3a847f75&scoped=true"
import script from "./AddressBox.vue?vue&type=script&lang=js"
export * from "./AddressBox.vue?vue&type=script&lang=js"
import style0 from "./AddressBox.vue?vue&type=style&index=0&id=3a847f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a847f75",
  null
  
)

export default component.exports